export default {
    unassignedOrdersDescription: 'Niet-toegewezen bestellingen zijn altijd inbegrepen.',
    today: 'Vandaag',
    tomorrow: 'Morgen',
    last7Days: 'Laatste 7 dagen',
    last2Weeks: 'Laatste 2 weken',
    lastMonth: 'Laatste maand',
    last3Months: 'Laatste 3 maanden',
    monthToDate: 'Maand tot nu toe',
    quarterToDate: 'Kwartaal tot nu toe',
    yearToDate: 'Jaar tot nu toe',
    onlyUnassignedOrders: 'Alleen niet-toegewezen bestellingen',
    selectMode: 'Selecteer modus',
    selectDateFieldPlaceholder: 'Selecteer een datumbereik...',
    reset: 'Resetten',
    selectStatuses: 'Selecteer status(sen)',
    selectDistributionZones: 'Selecteer terminal(s)',
    selectClients: 'Selecteer klant(en)',
    firebase10Limit: '10 limiet',
    distributionZones: 'terminals',
    selectCategories: 'Selecteer categorie(ën)',
    selectManufacturers: 'Selecteer fabrikant(en)',
    customViews: 'Aangepaste weergaven',
    fetchRecords: 'Gegevens ophalen',
    goToRecords: 'Ga naar records',
    goToRoutes: 'Ga naar routes',
    goToMapFleet: 'Ga naar kaart en vloot',
    goToReport: 'Ga naar rapport',
    goToLiveConnect: 'Ga naar Live Connect',
    goToAdmin: 'Ga naar Admin',
    openSearch: 'Open zoekopdracht',
    createDedicatedOrder: 'Maak toegewijde bestelling',
    createSingleOrder: 'Maak enkele bestelling',
    openBulkImport: 'Open bulkimport',
    checkBackLater: 'Kijk later voor meer',
    notApplicable: 'N/B',
    warning: 'Waarschuwing',
    language: 'Taal',
    'Coming Soon': 'Binnenkort',
    loadingMessage: 'RIJDEN VOOR BETERE BEDRIJFS- EN KLANTERVARINGEN',
    loadingMessage2: 'DE COMPLETE OPLOSSING VOOR DE SUPPLY CHAIN',
    loading: 'Laden...',
    ItemNumber: 'Artikelnummer',
    PrintQuantity: 'Afdrukhoeveelheid',
    internalError: 'Interne fout: Neem contact op met het Shyftbase-team',
    duplicateEntry: '{{value}} bestaat al. Voer een ander {{field}} in',
    login: {
        selectStore: 'Selecteer winkel',
        selectRegion: 'Selecteer regio',
        selectRole: 'Selecteer je rol',
        placeholder: {
            email: 'E-mail..',
            password: 'Wachtwoord..',
            verification: 'Voer hier je verificatiecode in.',
        },
        rules: {
            title: 'Wachtwoord moet bevatten:',
            characters: '8 tekens',
            number: 'Bevat cijfer',
            uppercase: 'Bevat hoofdletter',
            specialCharacters: 'Bevat speciaal teken',
        },
        messages: {
            verification: 'We hebben je een verificatiecode gestuurd.',
            captchaExpired: 'Sessie verlopen. Probeer het opnieuw.',
            redirectingToPortal: 'Even geduld, we sturen je naar het portal.',
            emailVerification: 'E-mailverificatie is verzonden. Controleer je inbox.',
            invalidAccount: 'Ongeldige account.',
            unsupportedAccess: 'Niet ondersteunde toegang. Log opnieuw in.',
            enterVerficationCode: 'Voer je verificatiecode in.',
            somethingWentWrong: 'Er is iets misgegaan. Probeer het opnieuw.',
            standardRate: 'Standaard tarieven kunnen van toepassing zijn.',
            firstTimeLogin: 'Heb je eerder een account gemaakt?',
            goBackToLogin: 'Ga naar inloggen',
            goBackToSignup: 'Ga naar aanmelden',
            createPassword: 'Maak een nieuw wachtwoord aan',
            confirmPassword: 'Bevestig wachtwoord',
            notMatch: 'Wachtwoord komt niet overeen',
            createAccount: 'Account aanmaken',
        },
        button: {
            submit: 'Verzenden',
            login: 'Inloggen',
            signup: 'Maak je account aan',
        },
        errorCode: {
            'auth/wrong-password': 'Het wachtwoord is ongeldig of de gebruiker heeft geen wachtwoord.',
            'auth/user-not-found':
                'Er is geen gebruikersrecord voor deze identificatie. De gebruiker kan zijn verwijderd.',
            'auth/invalid-email': 'Het e-mailadres is verkeerd geformatteerd.',
        },
        twofa: {
            secureAccess: 'Veilige toegang',
            sendBtn: 'Stuur een activatiecode',
        },
    },
    dashboard: {
        title: 'Dashboard',
        shyftbaseWatch: 'Shyftbase Monitor',
        shyftbaseWatchSubtitle: 'Shyftbase Monitor wordt geactiveerd zodra er voldoende gegevens zijn verzameld',
        shyftbaseWatchModal: {
            title: 'Shyftbase Monitor',
            message: 'Shyftbase Monitor wordt geactiveerd zodra er voldoende gegevens zijn verzameld.',
            buttonText: 'Ga naar Records Tabblad',
            closeAriaLabel: 'Sluit modaal',
        },
        operationsOverview: 'Operationeel Overzicht',
        orderCount: 'Aantal Bestellingen',
        unconfirmedPercent: 'Onbevestigd %',
        confirmedPercent: 'Bevestigd %',
        invoicedPercent: 'Gefactureerd %',
        activeRoutes: 'Actieve Routes',
        fleetUtilization: 'Vloot Benutting',
        avgDeliveryTime: 'Gem. Levertijd',
        ordersNeedingAttention: 'Bestellingen die aandacht vereisen',
        noOrdersNeedAttention: 'Momenteel hebben geen bestellingen aandacht nodig.',
        noOrdersDescription: 'Wanneer u bestellingen heeft die actie vereisen, verschijnen ze hier met details zoals:',
        noOrdersExamples: {
            addressVerification: 'Adresverificatie nodig',
            schedulingConflicts: 'Leveringsplanningsconflicten',
            paymentVerification: 'Betalingsverificatie in behandeling',
            specialHandling: 'Speciale behandelingsvereisten',
        },
        recommendations: 'Aanbevelingen',
        noRecommendations: 'Nog geen aanbevelingen beschikbaar.',
        noRecommendationsDescription: 'Naarmate uw systeem operationele gegevens verzamelt, verschijnen hier AI-aangedreven inzichten, waaronder:',
        noRecommendationsExamples: {
            routeOptimization: 'Route optimalisatiemogelijkheden',
            capacityPlanning: 'Suggesties voor capaciteitsplanning',
            preventiveMaintenance: 'Preventief onderhoudswaarschuwingen',
            costSaving: 'Kostenbesparende aanbevelingen',
        },
        quickActions: {
            title: 'Snelle Acties',
            orderTable: {
                title: 'Bestellingstabel',
                description: 'Live verzending en operatiesconsole',
            },
            uploadCsv: {
                title: 'CSV Uploaden',
                description: 'Bestellingen in bulk importeren',
            },
            liveConnect: {
                title: 'Live Connect',
                description: 'Klantverzoeken goedkeuren/afwijzen',
            },
            mapFleet: {
                title: 'Vloot Kaart',
                description: 'Vloot en routes monitoren',
            },
            search: {
                title: 'Zoeken',
                description: 'Klantenservice zoekopdrachten',
            },
            reports: {
                title: 'Rapporten',
                description: 'Operationele inzichten',
            },
            admin: {
                title: 'Admin',
                description: 'Instellingen en configuratie',
            },
        },
        dataPending: {
            title: 'Gegevens Laden...',
            description: 'Operationele gegevens verschijnen hier zodra het systeem bestellingen ontvangt en verwerkt.',
        },
    },
    nav: {
        addOrder: '+ Bestelling',
        search: 'Zoeken',
        orders: 'Bestellingen',
        logout: 'Uitloggen',
        tooltip: {
            orders: 'Trek records, voorraaditems en meer',
            mapFleet: 'Beheer je hubs, winkels en meer',
            report: 'Shyftbase-analyse en rapporten',
            assets: 'SKUs',
            trackOrder: 'Volg je bestellingen',
            admin: 'Beheer je instellingen en gebruikers',
            help: 'Hulp en ondersteuning',
            history: 'Geschiedenis',
            search: 'Zoeken',
            language: 'Taal',
            theme: 'Thema',
            profile: 'Profiel',
        },
        drawer: {
            handleUiModeMsg: `{{mode}} modus is ingeschakeld.`,
            info: 'Info',
            orders: 'Records',
            assets: 'SKUs',
            mapFleet: 'Vloot Kaarten',
            billingModule: 'Factureringsmodule',
            invoice: 'Factuur',
            home: 'Startpagina',
            search: 'Zoeken',
            liveConnect: 'Winkels',
            trackOrder: 'Tracking',
            newOrder: 'Nieuwe Bestelling',
            history: 'Geschiedenis',
            report: 'Analyse',
            admin: 'Admin',
            logout: 'Uitloggen',
            reverseLogistics: 'Omgekeerde Logistiek',
            language: 'Taal',
            help: 'Hulp',
            installations: 'Installaties',
            logistics: 'Logistiek',
            services: 'Diensten',
            mode: 'Mode',
        },
        header: {
            headerTitle: 'Records',
        },
    },
    search: {
        title: {
            title: 'Je kunt alleen goedgekeurde bestellingen zoeken',
            subtitle1: 'Om wachtende bestellingen te zoeken, ga naar ',
            subtitle2: 'wachtende bestellingen',
            msg: '* Het gebruik van een datumbereik wordt aanbevolen voor betere prestaties en efficiëntie',
        },
        label: {
            or: 'Of',
            firstName: 'Voornaam',
            lastName: 'Achternaam',
            phoneNumber: 'Telefoonnummer',
            address: 'Adres',
            invoice: 'Typ Factuurnummer en druk op enter',
            from: 'Van (Starttijdvak)',
            to: 'Tot (Eindtijdvak)',
            deliveryDate: 'Leverdatum',
            selectStatus: 'Selecteer Status',
            productName: 'Productnaam',
            barcode: 'Barcode',
            whid: 'WHID',
            sku: 'SKU',
            invoiceInput: 'Factuur',
            poNumber: 'PO Nummer',
            'Scanned In': 'Ingescand',
            'Scanned Out': 'Uitgescand',
        },
        button: {
            reset: 'RESET',
            search: 'ZOEKEN',
        },
        messages: {
            recordsFound: 'record(s) gevonden',
            noRecordsFound: 'Geen records gevonden',
            noInputErr: 'Voer minimaal één zoekwoord in om bestellingen te zoeken.',
            otherErr: 'Er is iets misgegaan. Neem contact op met Shyftbase.',
        },
        'Customer Info': 'Klantinformatie',
        'Order Details': 'Bestelgegevens',
        Statuses: 'Bestelstatussen',
        Products: 'Producten',
        'Reverse Logistics': 'Omgekeerde Logistiek',
        'Client Search': 'Klant',
        'Zone Search': 'Zone',
        'Minimize Tags': 'Minimaliseer Tags',
        'Show All Tags': 'Toon alle Tags',
        'Type to show or hide fields': 'Typ om velden te tonen of verbergen',
        'click to show': 'klik om te tonen',
        'click to hide': 'klik om te verbergen',
        selected: 'geselecteerd',
        'Search For Anything': 'Zoek naar iets',
        'Search Input Placeholder': 'Voorbeeld: Bestel #, Klantnaam, Klant, PO #, Product, Barcode, WHID, SKU',
    },
    liveConnect: {
        orderType: {
            needAttention: 'Behoeft Aandacht',
            pending: 'In afwachting (Klantportaal)',
            approved: 'Goedgekeurd',
            cancelled: 'Geannuleerd',
            customerRequest: 'Klantverzoek',
        },
        region: 'Regio',
        store: 'Winkel',
        invoice: 'Factuur',
        filter: 'Filter Bestellingen',
        loading: 'Gegevens laden ...',
    },
    liveOrdersContainer: {
        tooltip: {
            hideStops: 'Verberg stops',
            showStops: 'Toon stops',
        },
    },
    bulkImport: {
        messages: {
            duplicateInvoice: `Er zijn dubbele facturen voor de geselecteerde distributiezone en klant. Controleer je bestand en probeer het opnieuw.`,
            internealError: 'Bulkimport mislukt. Neem contact op met het Shyftbase-team.',
            success: 'Met succes geïmporteerd.',
        },
        templateSetting: {
            instruction: 'Kopieer je sheetlicentiesleutel van het CSV Box-account dat voor je is aangemaakt.',
            notFound: 'Geen sjablonen gevonden.',
            downloadInstruction: 'Je kunt het voorbeeldbestand downloaden door op het sjabloon te klikken.',
        },
    },
    rateTable: {
        notDefined:
            'Controleer de tarieftabel. Er zijn geen beschikbare diensten of de tarieftabel is niet gedefinieerd',
        messages: {
            otherErr: 'Er is iets misgegaan. Neem contact op met Shyftbase.',
        },
        connectingLoaderMessage: 'Verbinding maken met tarieven...',
        bulkEdit: {
            submit: 'Verzenden',
            close: 'Sluiten',
            warning: 'Dit zal de waarden van de tarieftabel overschrijven',
            title: 'Bulk Bewerken Tarieftabellen',
            success: 'Instellingen tarieftabel zijn bijgewerkt',
            noClients: 'Geen klanten geselecteerd',
            noDistributionZones: 'Geen distributiezones geselecteerd',
            confirmNullTitle: 'Bevestig Bulk Bewerking',
            confirmNullText: 'Er zijn geen waarden geselecteerd. Dit verwijdert alle vorige waarden.',
            differentTypeWarning: 'Selecteer tarieven van hetzelfde type.',
            noData: 'Geen waarden geselecteerd.',
        },
    },
    liveOrder: {
        orderType: {
            Delivery: 'Levering',
            Pickup: 'Ophalen',
            'Service Call': 'Serviceaanroep',
            'Store-Stop': 'Winkel-stop',
        },
        cancellationReason: {
            RESCHEDULE: 'HERPLAN',
            'NO STOCK': 'GEEN VOORRAAD',
            'CANCELLED BY CUSTOMER': 'GEANNULEERD DOOR KLANT',
            'ADDRESS NOT FOUND': 'ADRES NIET GEVONDEN',
            'ADULT NOT PRESENT': 'VOLWASSENE NIET AANWEZIG',
            'PREVIOUSLY DONE': 'EERDER GEDAAN',
            'BOOKING ERROR': 'BOEKINGSFOUT',
            'CANCELLED BY STORE': 'GEANNULEERD DOOR WINKEL',
            'CANCELLED TO RESCHEDULE': 'GEANNULEERD OM HER TE PLANNEN',
            'CREATED - NO STOCK': 'AANGEMAAKT - GEEN VOORRAAD',
            'DELIVERY TEAM ILLNESS / INJURY': 'ZIEKTE / LETSEL LEVERINGSTEAM',
            'DUPLICATE ORDER': 'DUBBELE BESTELLING',
            'FLY BY - NO PRODUCT AVAILABLE': 'FLY BY - GEEN PRODUCT BESCHIKBAAR',
            'INCORRECT ADDRESS': 'ONJUIST ADRES',
            'INCORRECT ADDRESS - NOT LOADED ON TRUCK': 'ONJUIST ADRES - NIET GELOADED OP VRACHTAUTO',
            'INSUFFICIENT MANPOWER': 'ONVOLDOENDE MANPOWER',
            'INSUFFICIENT MANPOWER - NOT LOADED ON TRUCK': 'ONVOLDOENDE MANPOWER - NIET GELOADED OP VRACHTAUTO',
            'NAH - OUTSIDE WINDOW': 'NAH - BUITEN VENSTER',
            'NO STOCK - MID MILE DELAY': 'GEEN VOORRAAD - MID-MILE VERTRAGING',
            'NO STOCK LOCATED AT HUB': 'GEEN VOORRAAD BEVINDT ZICH OP HUB',
            'OVERSIZED PRODUCTS(S)': 'OVERSIZE PRODUCTEN(S)',
            'PRODUCT NOT LOADED': 'PRODUCT NIET GELOADED',
            'PROPERTY DAMAGE': 'SCHADE AAN GOEDEREN',
            'PROPERTY NOT ACCESSIBLE': 'GOEDEREN NIET TOEGANKELIJK',
            'REFUSED - CONCEALED DAMAGE': 'GEWEIGERD - VERBORGEN SCHADE',
            'REFUSED - DRIVER DAMAGE': 'GEWEIGERD - SCHADE DOOR BESTUURDER',
            'REFUSED - INCORRECT PRODUCT ORDERED': 'GEWEIGERD - ONJUIST PRODUCT BESTELD',
            'REFUSED - INCORRECT PRODUCT SHIPPED': 'GEWEIGERD - ONJUIST PRODUCT VERZONDEN',
            'REFUSED - PRODUCT DEFECTIVE': 'GEWEIGERD - PRODUCT IS DEFECT',
            'RESCHEDULED BY CUSTOMER - NOT LOADED ON TRUCK': 'HERPLAN DOOR KLANT - NIET GELOADED OP VRACHTAUTO',
            'RESCHEDULED BY CUSTOMER': 'HERPLAN DOOR KLANT',
            'VEHICLE ISSUES': 'VOERTUIGPROBLEMEN',
            'WEATHER - NOT LOADED ON TRUCK': 'WEER - NIET GELOADED OP VRACHTAUTO',
            'WEATHER ISSUES': 'WEERPROBLEMEN',
        },
        orderStatus: {
            'Need Attention': 'Behoeft Aandacht',
            Pending: 'In afwachting (Klantportaal)',
            Cancelled: 'Geannuleerd',
            Approved: 'Goedgekeurd',
        },
    },
    orderEntry: {
        viewPendingOrder: 'Bekijk Wachtende Bestellingen',
        title: {
            create: 'Maak Nieuwe Bestelling',
            update: 'Werk Bestelling Bij',
        },
        subtitle: {
            zone: 'Zone: ',
            pickupDate: 'Ophalen Datum',
            deliveryDate: 'Leverdatum',
            scheduledDate: 'Geplande Datum',
            services: 'Diensten',
            products: 'Producten',
        },
        placeholder: {
            placeOrderTakingTimeMessage: 'Dit kan een paar seconden duren',
            select: 'Selecteer Bestellingstype',
            postalCode: 'Klant Postcode (Bijv: L0C1E0)',
            selectReturn: 'Selecteer Terugstuur Type',
            selectedDate: 'Geselecteerde Datum: ',
            additionalInfo: 'Aanvullende Informatie',
        },
        caution: {
            first: 'Als je een',
            second: 'afhaaldienst',
            third: 'inplant, selecteer dan alleen',
            fourth: 'dienstoptie.',
        },
        button: {
            check: 'Controleer Beschikbaarheid',
            submit: 'Verzenden',
        },
        messages: {
            submitError:
                'Sorry, het boeken van deze postcode is momenteel niet mogelijk! Controleer de ingevoerde postcode. Als je denkt dat dit een vergissing is, stuur dan een verzoek om deze postcode toe te voegen aan de ondersteunde zones naar hcustome@bestbuycanada.ca',
            selectActiveDate: 'Selecteer een actieve datum',
            saveProduct: 'Zorg ervoor dat de producten zijn opgeslagen!',
            saveService: 'Zorg ervoor dat de dienst is opgeslagen!',
            selectDate: 'Zorg ervoor dat de datum is geselecteerd!',
            validInvoice: 'Zorg ervoor dat de factuur geldig is!',
            validInvoiceFormat: 'Zorg ervoor dat het factuurnummer het formaat "XXX-XXXXXX" in cijfers heeft',
            validPhone: 'Zorg ervoor dat het telefoonnummer geldig is!',
            validFirstName: 'Zorg ervoor dat de voornaam geldig is!',
            validLastName: 'Zorg ervoor dat de achternaam geldig is!',
            validStreet: 'Zorg ervoor dat het straatadres geldig is!',
            validCity: 'Zorg ervoor dat de stad geldig is!',
            validUnit: 'Zorg ervoor dat het unitnummer geldig is!',
            orderAdded: 'Bestelling is toegevoegd aan de wachtlijst!',
            orderUpdated: 'Bestelling is succesvol bijgewerkt!',
            somethingWentWrong: 'Sorry, er is iets misgegaan. Sluit dit bericht en probeer opnieuw.',
            lanudryAndFridgeDoorMsg:
                'Bevestig dat het een nieuwe eenheid is of deze binnen 30 dagen door Metro To Home is gekocht en geleverd.',
            isAccessoriesNew: "Zijn alle accessoires nieuw of gebruikt? Klik 'Ja' als 'Nieuw', 'Nee' als 'Gebruikt'.",
            haulawayMsg:
                'Let op, je hebt een afvoeroptie geselecteerd, wat betekent dat het product voor recycling wordt gestuurd. Zorg ervoor dat de klant het product de-installeert en gereed maakt voor ophaling voordat ons team arriveert.',
            largeHawlawayMsg:
                'Let op, onze afvoeroptie is een één-op-één service. Controleer de gevraagde hoeveelheid en dien het opnieuw in.',
            generateLargeQtyMessage:
                'Dit is geen reguliere levering van een huis, dus zorg ervoor dat je de grote orderprocedure volgt op ETK.',
            generateFourManMessage:
                '4-mans levering: Zorg ervoor dat je details, SKU en hoeveelheid in de opmerkingen vermeldt.',
            generateReturnMessage:
                'Retour naar DC - Zorg ervoor dat je details (REDEN VOOR TERUGZENDING) in de opmerkingen vermeldt.',
            serviceConditionRequirement: 'de servicevoorwaarden zijn niet vervuld.',
            generateInvoiceAuthMessage: 'Sorry, alleen Admin heeft toestemming om 900 bestellingen te creëren.',
            oversizeFridge: 'Vermeld de details en SKU / hoeveelheid in de opmerkingen.',
            over90Days:
                'Je hebt een datum geselecteerd die de 90 dagen grens overschrijdt. Zorg ervoor dat de geselecteerde datum juist is.',
            usedAccessories:
                'Installatieaccessoires moeten nieuw en ongeopend zijn zodat onze thuislevering de installatie kan voltooien.',
            yes: 'Ja',
            no: 'Nee',
            duplicateInovice:
                'Het factuurnummer dat je hebt ingevoerd bestaat al voor de geselecteerde regio en klant. Voer een uniek factuurnummer in.',
        },
        options: {
            flyby: 'Fly By',
            serviceCall: 'Service Alleen',
            pickup: 'Ophalen',
        },
    },
    serviceList: {
        service: 'Dienst',
        qty: 'Hoeveelheid',
        remove: 'Verwijderen',
    },
    saveServiceForm: {
        selectService: 'Selecteer Dienst',
        saveService: 'Sla Dienst Op',
        qty: 'HOEVEELHEID',
        options: {
            fourMan: '4-mans levering - Specificeer details in opmerkingen',
            LevelUnit: 'Level Unit',
            MoveUnit: 'Verplaats eenheid op de plaats',
            Pedestal: 'Pedestal opzetten',
            StackingLaundry: 'Wasdroger stapelen',
            WasherConnection: 'Wasmachine aansluiting',
            DryerConnection: 'Drogers aansluiting',
            WasherandDryerConnection: 'Wasmachine en droger aansluiting',
            FridgeDoorSwing: 'Koelkastdeur draaier',
            OversizeFridge: 'Oversize Koelkast (+26/350LB)',
            Haulaway: 'Afvoeren',
            Doorstep: 'Deurmat',
        },
    },
    productList: {
        product: 'Product',
        qty: 'Hoeveelheid',
        sku: 'SKU',
        model: 'MODEL',
        remove: 'verwijderen',
    },
    saveProductForm: {
        name: 'PRODUCTNAAM',
        qty: 'HOEVEELHEID',
        sku: 'SKU',
        model: 'MODEL',
        save: 'Sla Product Op',
    },
    history: {
        loading: 'Laden...',
        filter: 'filter',
        group: 'bestellingen groeperen',
        sort: 'bestellingen sorteren',
    },
    viewSettings: {
        deleteConfirmation: 'Weet u zeker dat u deze weergave wilt verwijderen?',
        deleteWarning: 'Dit zal de weergave "{{name}}" en al zijn instellingen verwijderen.',
        delete: 'Verwijderen',
        cancel: 'Annuleren',
        noViews: 'Geen weergaven gevonden',
        emptyState: {
            title: 'Geen weergaven beschikbaar',
            description: 'Bewaar je favoriete filters en datumbereiken als weergaven om later te gebruiken. Deel weergaven met externe partijen voor snelle alleen-lezen toegang.',
            createFirstView: 'Maak je eerste weergave om te beginnen'
        },
        type: 'Type',
        shareLink: 'Link delen',
        regions: 'Regio\'s',
        clients: 'Klanten',
        dateRange: 'Datumbereik',
        copyLink: 'Link kopiëren',
        sharingSettings: 'Delen',
        warning: {
            accessClientZones: `U heeft geen toegang tot de klanten of distributiezones van deze weergave.`,
            selectView: 'U moet een nieuwe weergave maken of de opgeslagen weergave laden vanuit het weergavemenu',
            bindClientZones: `Deze weergave heeft geen gekoppelde klant en distributiezone. Maak een nieuwe weergave met koppeling`,
        },
        createNewView: 'Nieuwe weergave maken',
        name: 'Naam',
        enterName: 'Voer de naam van de weergave in...',
        configurationSaved: 'Wat deze weergave opslaat',
        visibleColumns: 'Zichtbare kolommen',
        columnOrder: 'Kolomvolgorde',
        grouping: 'Groepering',
        appliedFilters: 'Toegepaste filters',
        create: 'Weergave maken',
        personal: 'Persoonlijk',
        shared: 'Gedeeld',
        bindClientDistributionzones: 'De huidige klanten, distributiezones en datumbereik opslaan',
        bindClientZonesHelp: 'Klanten en zones worden met de weergave opnieuw geladen. Het datumbereik wordt alleen voor de externe link opgeslagen — in het portaal volgt de weergave het datumbereik dat u hebt geselecteerd. Zonder deze instelling gebruikt de weergave de op dat moment geselecteerde klanten en zones en past alleen de datumoptie hierboven toe.',
        columnLayoutSaved: 'De huidige kolomindeling — welke kolommen zichtbaar zijn en in welke volgorde — wordt altijd opgeslagen.',
        shareExternally: 'Een deelbare externe link maken',
        shareExternallyHelp: 'Iedereen met de link kan deze weergave openen zonder in te loggen. U kunt op elk moment een wachtwoord instellen, kopiëren toestaan of de link weer uitschakelen via de weergave-instellingen.',
        shareExternallyRequires: 'Zet eerst de instelling hierboven aan. Een gedeelde link heeft geen ingelogde gebruiker om klanten, zones en een datumbereik van over te nemen en werkt dus alleen bij een weergave die deze zelf heeft opgeslagen.',
        linkAvailableAfterCreate: 'De link wordt aangemaakt zodra de weergave is gemaakt. U kunt deze daarna kopiëren via de weergave-instellingen.',
        copyToClipboard: 'Link gekopieerd naar klembord. U kunt deze nu delen',
        hasClientZones: 'Bevat gekoppelde klanten & zones',
        passwordProtected: 'Wachtwoord beveiligd',
        error: {
            fetchFailed: 'Kan weergaven niet ophalen. Probeer het opnieuw.',
            copyFailed: 'Kan link niet kopiëren. Probeer het opnieuw.',
            updateFailed: 'Kan weergave niet bijwerken. Probeer het opnieuw.',
            deleteFailed: 'Kan weergave niet verwijderen. Probeer het opnieuw.',
        },
        sharedView: {
            setPassword: {
                title: 'Een wachtwoord is vereist om deze inhoud te bekijken',
                subTitle: 'Dit wachtwoord is niet hetzelfde als het wachtwoord van uw Shyftbase-account',
            },
            allowCopy: 'Gegevenskopie toestaan',
            showAllFields: 'Alle velden in uitgebreide records tonen',
            restrictAccess: 'Beperken met wachtwoord',
            disable: 'Link uitschakelen',
            enable: 'Link inschakelen',
            notAvailable: {
                title: 'De privé-deellink die u probeerde te bereiken is niet beschikbaar.',
                subTitle:
                    'De eigenaar van deze weergave heeft deze mogelijk niet meer gedeeld of verwijderd. Neem contact met hen op als u toegang nodig heeft.',
            },
            verifyPassword: 'Voer wachtwoord in om inhoud te bekijken',
            wrongPassword: 'Onjuist wachtwoord. Probeer het opnieuw.',
        },
        new: 'Nieuw',
        searchViews: 'Zoek weergaven...',
        personalViews: 'Persoonlijk',
        noPersonalViews: 'Geen persoonlijke weergaven gevonden.',
        sharedViews: 'Gedeeld',
        noSharedViews: 'Geen gedeelde weergaven gevonden.',
        startWindow: 'Startvenster',
        manageSharing: 'Weergave-instellingen',
        sharedViaLink: 'Gedeeld via externe link',
        pullScope: 'Opgehaalde gegevens',
        tableLayout: 'Tabelindeling',
        groupedBy: 'Gegroepeerd op',
        filters: 'Filters',
        notGrouped: 'Niet gegroepeerd',
        noFilters: 'Geen filters',
        dateBasis: 'Datum',
        dateRangeExternalOnly: 'Wordt alleen door de externe link gebruikt. In het portaal gebruikt deze weergave altijd het datumbereik dat u hebt geselecteerd.',
        allZones: 'Alle distributiezones',
        allClients: 'Alle klanten',
        none: 'Geen',
        dateOptions: {
            today: 'Vandaag',
            tomorrow: 'Morgen',
            yesterday: 'Gisteren',
            none: 'Geen datum opgeslagen',
        },
        howToUpdate: {
            title: 'Deze weergave bijwerken',
            layout: 'Tabelindeling — orden de kolommen, groepering en filters in het raster zoals u wilt en klik daarna op het opslaanpictogram van deze weergave in het paneel.',
            scope: 'Klanten, zones en datumbereik — alleen weergaven die met de huidige klanten en distributiezones zijn opgeslagen behouden deze. Wijzig ze in het ophaalformulier, haal op en klik daarna op opslaan. Het opgeslagen datumbereik wordt alleen door de externe link gebruikt; in het portaal volgt deze weergave altijd het datumbereik dat u hebt geselecteerd.',
            fixed: 'De naam, de modus en de binding aan specifieke klanten en distributiezones liggen vast bij het aanmaken. Maak een nieuwe weergave om ze te wijzigen. (Dit heeft geen invloed op de deellink hierboven, die u altijd aan en uit kunt zetten.)',
        },
    },
    calendarSettings: {
        title: {
            title: 'Kalenderinstelling',
            selectDistributionZoneAndClient: 'Selecteer distributiezone en klant om te starten',
        },
        placeholder: {
            selectZone: 'Selecteer Zone',
            selectMonth: 'selecteer maand',
            selectBDays: 'selecteer werkdagen',
        },
        setMaxBooking: 'Stel maximale boekingsdatum in',
        subSetMaxBooking: '(Hoe ver van tevoren moeten klanten kunnen boeken)',
        monthFromToday: 'maand(en) vanaf vandaag',
        submit: 'verzenden',
        setEarliestBooking: 'Stel de vroegste beschikbare dagen in, inclusief vandaag',
        subSetMinBooking:
            '(bijv. 2 betekent dat de vroegste beschikbare datum 2 werkdagen na de plaatsing van de levering zal zijn)',
        includingToday: 'werkdagen inclusief vandaag',
        messages: {
            changePostalCode:
                'Aangepaste dagen boven overschrijven de postcodeschema’s. Als je de postcodeschema’s wilt wijzigen, neem dan contact met ons op via admin@shyftbase.com.',
            followingDate: 'de volgende datum',
            default: 'Verander terug naar standaard dienstenplanning op basis van postcodes.',
        },
        colorCodes: 'Kleurcodes: ',
        disabledDays: 'uitgeschakelde dagen',
        enabledDays: 'ingeschakelde dagen',
        select: 'selecteer',
        enable: 'inschakelen',
        disable: 'uitschakelen',
        updateCalener: 'Update Kalenderinstelling',
        warning: {
            overwrite:
                'Er zijn vooraf gedefinieerde instellingen voor de volgende klanten.<br/>Dit werk zal de instellingen overschrijven.',
        },
    },
    distributionZoneMapping: {
        subtitle: 'Distributiezone Mapping - Selecteer regio om te beginnen',
        'Select Region': 'Selecteer Regio',
        'Select Distribution Zones': 'Typ en zoek Distributiezone',
        'Currently Mapped Distribution Zones': 'Huidig Gemapte Distributiezones',
        Update: 'Bijwerken',
        Reset: 'Resetten',
        None: 'Geen',
        Updated: 'Bijgewerkt {0} Distributiezones',
        Added: 'Toegevoegd {0} aan Regio-lijst',
    },
    clientSetting: {
        error: {
            IncompletForm:
                'Formulier is incompleet! Bedrijfseenheid, Sub bedrijfseenheid, Regio’s en Gegevensbron mogen niet leeg zijn',
        },
    },
    accessTable: {
        accessLevels: 'Toegangsrechten',
        toggle: 'Schakel toegangshierarchie in',
        save: 'Opslaan',
        searchByName: 'Zoeken op naam...',
        noUser: 'Geen gebruikers gevonden',
        emailAdmin: '',
        name: 'Naam',
        access: 'Toegang',
        'Create a new one': 'Maak een nieuwe aan',
        'User access updated': 'Gebruikersrechten bijgewerkt',
        Region: 'Regio',
        Actions: 'Acties',
        Client: 'Klant',
        Vendor: 'Klant',
    },
    updateOrderInfo: {
        title: 'Werk Bestelling Bij',
        startWindow: 'Startvenster',
        selectedDate: 'Geselecteerde Datum: ',
        services: 'Diensten',
        products: 'Producten',
        additionalInfo: 'Aanvullende Info',
        submit: 'Verzenden',
        ok: 'OK',
        messages: {
            somethingWentWrong: 'Er is iets misgegaan! Probeer het opnieuw.',
            pending: 'Bestelling is bijgewerkt naar de wachtlijst!',
        },
    },
    orderDisplay: {
        tooltip: {
            confirmUnconfirmBillingState: 'Bevestig / de-bevestig de factureringstoestand van de bestelling',
            confirmUnconfirmSettlementState: 'Bevestig / de-bevestig de afwikkelingstoestand van de bestelling',
            confirmUnconfirmBothState: 'Wissel de facturering- & afwikkelingstoestand van de bestelling',
            lockBillingState:
                'Vergrendel de factureringstoestand van de bestelling. Dit voorkomt dat de bestelling opnieuw wordt bijgewerkt tenzij de bestelling wordt de-bevestigd',
            lockSettlementState:
                'Vergrendel de afwikkelingstoestand van de bestelling. Dit voorkomt dat de bestelling opnieuw wordt bijgewerkt tenzij de bestelling wordt de-bevestigd',
            unlockVehicle: 'Ontgrendel het voertuig. Vergrendelde voertuigen kunnen niet worden bijgewerkt',
            operationStatus: 'Operationele status',
            serviceList: '{{mode}} Dienstlijst',
        },
    },
    orderDetailModal: {
        requestInfo: 'Aanvraag Info (Verplaats naar Behoeft Aandacht)',
        typeMessage: 'Typ je bericht',
        approve: 'Goedkeuren Bestelling',
        areYouSure: 'Weet je het zeker?',
        yes: 'Ja',
        no: 'Nee',
        cancelOrder: 'Bestelling Annuleren',
        update: 'Bijwerken',
        selectAction: 'Selecteer Actie/Bekijk Details',
    },
    orderDetail: {
        invoice: 'Factuur / Bestelnummer',
        customer: 'Klant',
        email: 'E-mail',
        phone1: 'Telefoon 1',
        phone2: 'Telefoon 2',
        products: 'Producten',
        services: 'Diensten',
        startWindow: 'Startvenster',
        address: 'Adres',
        pickupAddress: 'Ophalen Adres',
        dispatchComments: 'Verzendcommentaren',
    },
    cancellationHandler: {
        selectReasonTitle: 'Selecteer Reden',
        options: {
            RESCHEDULE: 'HERPLAN',
            'NO STOCK': 'GEEN VOORRAAD',
            'CANCELLED BY CUSTOMER': 'GEANNULEERD DOOR KLANT',
            'ADDRESS NOT FOUND': 'ADRES NIET GEVONDEN',
            'ADULT NOT PRESENT': 'VOLWASSENE NIET AANWEZIG',
            'PREVIOUSLY DONE': 'EERDER GEDAAN',
            'BOOKING ERROR': 'BOEKINGSFOUT',
            'CANCELLED BY STORE': 'GEANNULEERD DOOR WINKEL',
            'CANCELLED TO RESCHEDULE': 'GEANNULEERD OM HER TE PLANNEN',
            'CREATED - NO STOCK': 'AANGEMAAKT - GEEN VOORRAAD',
            'DELIVERY TEAM ILLNESS / INJURY': 'ZIEKTE / LETSEL LEVERINGSTEAM',
            'DUPLICATE ORDER': 'DUBBELE BESTELLING',
            'FLY BY - NO PRODUCT AVAILABLE': 'FLY BY - GEEN PRODUCT BESCHIKBAAR',
            'INCORRECT ADDRESS': 'ONJUIST ADRES',
            'INCORRECT ADDRESS - NOT LOADED ON TRUCK': 'ONJUIST ADRES - NIET GELOADED OP VRACHTAUTO',
            'INSUFFICIENT MANPOWER': 'ONVOLDOENDE MANPOWER',
            'INSUFFICIENT MANPOWER - NOT LOADED ON TRUCK': 'ONVOLDOENDE MANPOWER - NIET GELOADED OP VRACHTAUTO',
            'NAH - OUTSIDE WINDOW': 'NAH - BUITEN VENSTER',
            'NO STOCK - MID MILE DELAY': 'GEEN VOORRAAD - MID-MILE VERTRAGING',
            'NO STOCK LOCATED AT HUB': 'GEEN VOORRAAD BEVINDT ZICH OP HUB',
            'OVERSIZED PRODUCTS(S)': 'OVERSIZE PRODUCTEN(S)',
            'PRODUCT NOT LOADED': 'PRODUCT NIET GELOADED',
            'PROPERTY DAMAGE': 'SCHADE AAN GOEDEREN',
            'PROPERTY NOT ACCESSIBLE': 'GOEDEREN NIET TOEGANKELIJK',
            'REFUSED - CONCEALED DAMAGE': 'GEWEIGERD - VERBORGEN SCHADE',
            'REFUSED - DRIVER DAMAGE': 'GEWEIGERD - SCHADE DOOR BESTUURDER',
            'REFUSED - INCORRECT PRODUCT ORDERED': 'GEWEIGERD - ONJUIST PRODUCT BESTELD',
            'REFUSED - INCORRECT PRODUCT SHIPPED': 'GEWEIGERD - ONJUIST PRODUCT VERZONDEN',
            'REFUSED - PRODUCT DEFECTIVE': 'GEWEIGERD - PRODUCT IS DEFECT',
            'RESCHEDULED BY CUSTOMER - NOT LOADED ON TRUCK': 'HERPLAN DOOR KLANT - NIET GELOADED OP VRACHTAUTO',
            'RESCHEDULED BY CUSTOMER': 'HERPLAN DOOR KLANT',
            'VEHICLE ISSUES': 'VOERTUIGPROBLEMEN',
            'WEATHER - NOT LOADED ON TRUCK': 'WEER - NIET GELOADED OP VRACHTAUTO',
            'WEATHER ISSUES': 'WEERPROBLEMEN',
        },
    },
    orderInfo: {
        placeholder: {
            invoice: 'Factuur/waarde',
            firstName: 'Voornaam',
            lastName: 'Achternaam',
            phone1: 'Telefoon 1',
            phone2: 'Telefoon 2',
            email: 'E-mail',
            appt: 'Appartement',
            unit: 'Eenheid #',
            street: 'Straat / Rij',
            city: 'Stad / Plaats',
            postalCode: 'Postcode',
        },
    },
    bbUserAccessCell: {
        selectOrderType: 'Selecteer Bestellingstype',
    },
    chatHistory: {
        title: 'Chatgeschiedenis',
        reply: 'Beantwoorden',
        submit: 'Verzenden',
    },
    report: {
        dateRangeMsg: '* Als het datumbereik langer is dan 2 weken, gebruik dan `Download rapporten - archief`',
        liveArchiveDataSourceMsg:
            '* Om ervoor te zorgen dat je de meest recente resultaten van de vorige dag hebt, download dan het rapport uit de live gegevensbron.',
        download: 'Download rapporten',
        donwloadFromLiveData: 'Download rapporten - live gegevens',
        downloadData: 'Download gegevens',
        viewReport: 'Bekijk Rapport',
        selectDateRange: 'Selecteer Datumbereik',
        success: 'Rapport is succesvol gedownload.',
        noDate: 'Datum is niet geselecteerd',
        noRecords: 'Geen records gevonden. Stel een ander datumbereik in en probeer het opnieuw',
        noAuth: 'Gebruiker niet geautoriseerd. Alleen geautoriseerd personeel kan rapporten downloaden.',
        liveDataMsg:
            '* Live Gegevens: Scope is beperkt tot de live gegevens. Gebruik het archiefextract als je historische gegevens wilt downloaden.',
        'Download survey report - comments': 'Download enquête rapport - opmerkingen',
    },
    fields: {
        Invoice: 'Factuur',
        OrderType: 'Bestellingstype',
        StartWindow: 'Startvenster',
        EndWindow: 'Eindvenster',
        Products: 'Producten',
        actions: 'Acties',
        OrderStatus: 'Bestelstatus',
        CustomerName: 'Klantnaam',
        Phone1: 'Telefoon 1',
        Phone2: 'Telefoon 2',
        Email: 'E-mail',
        PickupAddress: 'Ophalen Adres',
        DropoffAddress: 'Afgifte Adres',
        DriverNotes: 'Bestuurder Notities',
        DriverServices: 'Bestuurder Diensten',
        PlannedServices: 'Geplande Diensten',
        StartedAt: 'Gestart Op',
        ArrivedAt: 'Aangekomen Op',
        CompletedAt: 'Voltooid Op',
        BestBuyRobocallStatus: 'Robocall Status',
        BestBuySurveyQ1: 'Enquête Q1',
        BestBuySurveyQ2: 'Enquête Q2',
        BestBuySurveyQ3: 'Enquête Q3',
        BestBuySurveyQ4: 'Enquête Q4',
        BestBuySurveyQ5: 'Enquête Q5',
        BestBuySurveyQ6: 'Enquête Q6',
        BbGiftCustomerEmail: 'Geschenkgift Email',
        BbGiftAmount: 'Geschenkgift Bedrag',
        CancellationReason: 'Reden Annulering',
        CalledCallCenter: 'Belde CallCenter',
        BbCustomerEmailForSurvey: 'Enquête Email',
        BbCustomerSurveyComment1: 'Enquête Commentaar 1',
        BbCustomerSurveyComment2: 'Enquête Commentaar 2',
        BestBuyRobocallTimestamp: 'Robocall Tijdstempel',
        Services: 'Diensten',
        Region: 'Regio',
        DeliveryAssignee: 'Leverings Verantwoordelijke',
        Vehicle: 'Voertuig',
        DispatchComments: 'Verzendcommentaar',
        ServiceTime: 'Dientijd',
        DispatchLog: 'Verzendlog',
        Store: 'Winkel',
        Pod: 'POD',
        CustomerSignature: 'Klantenhandtekening',
        DistributionZone: 'Distributiezone',
        Client: 'Klant',
    },
    vuetableDetailModal: {
        orderInfo: 'BESTELLINGSINFORMATIE',
        imageAttachment: 'AFBEELDING BIJLAGE',
        productDetail: 'PRODUCTDETAILS',
        product: {
            Product: 'Product',
            QTY: 'Hoeveelheid',
            SKU: 'SKU',
            WEIGHT: 'GEWICHT',
            MANUFACTURER: 'Fabrikant',
            VOLUME: 'VOLUME',
            SERIAL: 'SERIE',
            MODEL: 'MODEL',
            BARCODE: 'BARCODE',
            COMMENT: 'COMMENTAAR',
        },
        driverNotes: 'Bestuurder Notities',
        textMsgLogs: 'Tekstbericht Log',
    },
    admin: {
        tooltip: {
            taxRates: 'Beheer BTW-tarieven',
            integrations: 'Integraties',
            role: 'Maak en beheer rollen, veldinstellingen, toegangspunten en privileges',
            client: 'Stel je klantprofielen in',
            contractor: 'Stel je aannemersprofielen in',
            user: 'Maak en beheer gebruikers of chauffeurs (agenten)',
            orderStatus: 'Beheer alle statussen in het systeem',
            calendar: 'Beheer kalenders om boekingsdata of klantverplaatsingen toe te staan of te beperken',
            notification: 'Beheer meldingen en waarschuwingen',
            automation: 'Beheer automatiseringsinstellingen',
            fields: 'Beheer instellingen voor bestelvelden',
            rateTable: 'Beheer aangepaste tariefkaarten die door de automatische factureringsmodule worden gebruikt',
            zones: 'Beheer zones op basis van kilometerbanden, postcodes of andere criteria',
            services: 'Tabel met wereldwijde diensten. Je kunt de diensten per tariefkaart later beheren',
            conditions: 'Beheer facturerings- en afwikkelingsvoorwaarden',
            tiersEscrow: 'Stel tiers en escrow in',
            fuelSurcharge: 'Beheer brandstoftoeslagen',
            weeklyFuelSurcharge: 'Upload en beheer je wekelijkse brandstoftoeslagtarieven',
            ikeaPostalCodes: 'Beheer postcodes',
            globalUnits: 'Beheer meeteenheden',
        },
        SetupYourBusiness: 'Stel je bedrijf in',
        SetupBillingModule: 'Stel de factureringsmodule in',
        Automations: 'Automatiseringen',
        Integrations: 'Integraties',
        'Admin Settings': 'Instellingen',
        'Your Business, Your Way': 'Jouw bedrijf, jouw manier',
        'Access Table': 'Gebruikers Toegangsbeheer',
        'Admin Action': 'Admin Actie',
        'Calendar Settings': 'Kalenderinstellingen',
        'Driver Settings': 'Chauffeurinstellingen',
        'Distribution Zone Mapping': 'Distributiezone Mapping',
        'Client Settings': 'Klantinstellingen',
        'Fleet Settings': 'Vlootinstellingen',
        'Contactless Delivery Settings': 'Contactloze Levering Instellingen',
        'Metro Driver Settings': 'Metro Chauffeurinstellingen',
        'Role Settings': 'Rolinstellingen',
        'User Management': 'Gebruikersbeheer',
        'Business Logic Center': 'Bedrijfslogica Centrum',
        'Client Profile Settings': 'Klantprofielen',
        'Contractor Profile Settings': 'Aannemersprofielen',
        'General Settings': 'Algemene Instellingen',
        'Notification Settings': 'Meldingsinstellingen',
        'Postal Codes': 'Postcodes',
        displayName: 'Beheer API-sleutels',
        fields: {
            Yes: 'Ja',
            No: 'Nee',
            Cancel: 'Annuleren',
            'Add New User': '+ Nieuwe Gebruiker',
            'Create Vendor Profile': 'Maak Klantprofiel aan',
            'Edit Vendor Profile': 'Werk Klantprofiel bij',
            'Delete Vendor Profile': 'Verwijder Klantprofiel',
            'Create Contractor Profile': 'Maak Aannemersprofiel aan',
            'Edit Contractor Profile': 'Bewerk Aannemersprofiel',
            'Delete Contractor Profile': 'Verwijder Aannemersprofiel',
            'Business Unit': 'Bedrijfseenheid',
            'Sub Business Unit': 'Sub Bedrijfseenheid',
            'Company Name': 'Bedrijfsnaam',
            Active: 'Actief',
            Escrow: 'Escrow',
            address: 'Adres',
            allowAllRegion: 'Sta alle regio’s toe',
            billingCode: 'Factureringscode',
            businessUnit: 'Bedrijfseenheid',
            customerCanReschedule: 'Klant kan herplannen',
            customerRescheduleAvailableDayThreshold: 'Beschikbare herplan-dagen drempel voor klant',
            dataSource: 'Gegevensbron',
            id: 'ID',
            inventory: 'Voorraad',
            invoiceTemplate: 'Factuursjabloon',
            logoDownloadURL: 'Logo URL',
            logoFile: 'Logo bestand',
            regions: 'Regio’s',
            reverseLogistics: 'Omgekeerde logistiek',
            settlementTemplate: 'Afwikkelingssjabloon',
            shouldGeocode: 'Moet Geocoderen',
            shouldSendSurvey: 'Moet Enquête Verzenden',
            subBusinessUnit: 'Sub Bedrijfseenheid',
            trucks: 'Vrachtwagens',
            table: 'Tabel',
            tier: 'Tier',
            minPayable: 'Minimale Betaalbaar',
        },
        automations: {
            actionButtonTitle: '+ Automatiseringen',
        },
        userHistory: {
            limitInfo:
                'De geschiedenis is beperkt tot de laatste 300 items. Een uitbreiding zal later worden toegevoegd.',
        },
        fieldsSettings: {
            title: 'Voeg & Definieer Nieuwe Velden: Ontwerp je Eigen Logica voor Verbeterde Operaties Door je Bedrijf',
        },
        deleteConfirmModal: {
            title: 'Bevestig Verwijdering',
            warningTitle: `Waarschuwing: Het verwijderen van deze {{category}} zal leiden tot het volgende.`,
            warningDescription1: `Alle tarieftabellen die naar deze {{category}} verwijzen, zullen deze associatie verliezen.`,
            warningDescription2: `Deze {{category}} zal niet langer worden meegenomen in berekeningen voor bestaande bestellingen.`,
            confirmDelete: `Weet je zeker dat je door wilt gaan met het verwijderen van deze {{category}}?`,
        },
    },
    contractorSettings: {
        error: {
            missingCompanyName: 'Bedrijfsnaam is verplicht',
            missingTier: 'Tier is verplicht',
            duplicateContractor: 'Aannemer bestaat al',
        },
    },
    driverSettings: {
        Create: 'Aanmaken',
        Update: 'Bijwerken',
        Delete: 'Verwijderen',
        Confirm: 'Bevestigen',
        Created: 'Aangemaakt {0}',
        Updated: 'Bijgewerkt {0}',
        Deleted: 'Verwijderd',
        'Type new name here': 'Type hier nieuwe naam',
        'Type Delivery Assignee ID': 'Type ID van de Leveringsverantwoordelijke',
        'is not found': 'is niet gevonden',
        'Type New Contractor To Create': 'Type Nieuwe Aannemer om aan te maken',
        'No Driver was found in system': 'Geen chauffeur gevonden in het systeem',
    },
    driverInfo: {
        Name: 'Naam',
        Company: 'Bedrijf',
        Username: 'Gebruikersnaam',
        Password: 'Wachtwoord',
        'Fleet Id': 'Vloot ID',
        'Read Only': 'Alleen Lezen',
    },
    newUserForm: {
        'Create a new user': 'Maak een nieuwe gebruiker',
        'First Name': 'Voornaam',
        'First name is required': 'Voornaam is verplicht',
        'Invalid first name': 'Ongeldige voornaam',
        'Last Name': 'Achternaam',
        'Last name is required': 'Achternaam is verplicht',
        'Invalid last name': 'Ongeldige achternaam',
        'Store/Admin': 'Winkel / Admin',
        'Store is required': 'Winkel is verplicht',
        Admin: 'Admin',
        'Admin is required': 'Admin is verplicht',
        Phone: 'Telefoon',
        'Phone is required': 'Telefoon is verplicht',
        'Type only numbers without country code': 'Typ alleen nummers zonder landcode',
        Email: 'E-mail',
        'Email is required': 'E-mail is verplicht',
        'Invalid email': 'Ongeldige e-mail',
        Reset: 'Resetten',
        'Create user': 'Maak gebruiker aan',
        'saved user': ' is succesvol opgeslagen!',
        'Update User': 'Werk gebruiker bij',
        Close: 'Sluiten',
    },
    notification: {
        accessDenied: 'Toegang geweigerd. Controleer je toegangslevel.',
        orderAssignment: 'Ordertoewijzing',
        assigned: 'Toegewezen',
        unassigned: 'Niet toegewezen',
        orderAssignmentSubtitle: 'Niet-toegewezen orders hebben nog geen doelstellingdatum',
        parametersRemoved: '{{parameters}} zijn verwijderd omdat ze niet geldig zijn voor niet-toegewezen orders.',
    },
    reports: {
        'Select Report Type': 'Selecteer Rapporttype',
        'Currently Assigned Recipients': 'Momenteel toegewezen ontvangers',
        'Type email here': 'Typ e-mail hier...',
        'Type Recipients Email and Hit Enter': 'Typ e-mailadres van ontvanger en druk op Enter',
        'Reicipients list updated': 'Ontvangerslijst bijgewerkt',
    },
    Billing: {
        Hello: 'Hallo',
        ViewInvoices: 'Bekijk Facturen',
        BackToOverView: 'Terug naar Overzicht',
        'Last Month Overview': 'Overzicht van Vorige Maand',
        'Select Month': 'Selecteer Maand',
        'Download Supporting Data': 'Download Ondersteunende Gegevens',
        'Download Invoice': 'Download Factuur',
        'Total Orders': 'Totaal Bestellingen',
        Commingled: 'Gemixt',
        Dedicated: 'Gegevens',
        orders: 'bestellingen',
        stops: 'stops',
        Scanned: 'Ingescand',
        Returns: 'Retouren',
        'Driver Requests': 'Chauffeur Verzoeken',
    },
    forgotPassword: {
        'Reset password link was sent your email': 'Resetwachtwoordlink is naar je e-mail gestuurd',
        'Reset password': 'Reset wachtwoord',
        'Please type your email': 'Voer je e-mail in',
        'forgot password': 'Wachtwoord vergeten?',
    },
    allFields: {
        actions: 'Acties',
        NumberOfDoorRemovals: 'Aantal Deurverwijderingen',
        NumberOfExtraPieces: 'Aantal Extra Stukken',
        NumberOfFridgeLineInstalls: 'Aantal Koelkastlijninstallaties',
        NumberOfAdjustables: 'Aantal Verstelbare Eenheden',
        NumberOfPedInstalls: 'Aantal Pedestal Installaties',
        NumberOfScrap: 'Aantal Afval',
        NumberOfStacks: 'Aantal Stacks',
        NumberOfWasherDryerInstalls: 'Aantal Wasmachine/Droger Installaties',
        Charge100: 'Charge100',
        TotalHours2Man: 'Totaal Uren 2-man',
        TotalHours3Man: 'Totaal Uren 3-man',
        Charge50: 'Charge50',
        AddToCage: 'Toevoegen Aan Kooi',
        DriverServices: 'Chauffeurdiensten',
        ApprovedForBilling: 'Goedgekeurd Voor Facturering',
        ArchiveStatus: 'Archiefstatus',
        ArrivedAt: 'Aangekomen Op',
        PlannedServices: 'Geplande Diensten',
        Autobill: 'Autofacturatie',
        AutoContractorBill: 'Auto Aannemer Factuur',
        AutoContractorBillEdited: 'Auto Aannemer Factuur Bewerkt',
        Barcodes: 'Barcodes',
        BarcodesMatched: 'Barcodes Overeenkomend',
        BbCustomerEmailForSurvey: 'Bb Klant E-mail Voor Enquête',
        BbCustomerSurveyComment1: 'Bb Klant Enquête Opmerking1',
        BbCustomerSurveyComment2: 'Bb Klant Enquête Opmerking2',
        BbGiftAmount: 'Bb Gift Bedrag',
        BbGiftCustomerEmail: 'Bb Gift Klant E-mail',
        BestBuyRobocallStatus: 'Best Buy Robocall Status',
        BestBuyRobocallTimestamp: 'Best Buy Robocall Tijdstempel',
        BestBuyRobocallSent: 'Best Buy Robocall Verzonden',
        BestBuySurveyQ1: 'Best Buy Enquête Q1',
        BestBuySurveyQ2: 'Best Buy Enquête Q2',
        BestBuySurveyQ3: 'Best Buy Enquête Q3',
        BestBuySurveyQ4: 'Best Buy Enquête Q4',
        BestBuySurveyQ5: 'Best Buy Enquête Q5',
        BestBuySurveyQ6: 'Best Buy Enquête Q6',
        BillingInfo: 'Facturatie Info',
        BillingValidated: 'Facturatie Gevalideerd',
        CalledCallCenter: 'Belde Callcenter',
        CityDistance: 'Stad Afstand',
        Client: 'Klant',
        CoastLocation: 'Kust Locatie',
        OrderStatus: 'Bestelstatus',
        CompletedAt: 'Voltooid Op',
        CompletedStops: 'Voltooide Stops',
        CancellationReason: 'Reden Annulering',
        ContractorName: 'Naam Aannemer',
        ContractorPay: 'Betaling Aannemer',
        ContractorPayNotes: 'Betaling Aannemer Opmerkingen',
        CustomerComment: 'Klantcommentaar',
        CustomerName: 'Klantennaam',
        CustomerRating: 'Klantbeoordeling',
        CustomerSignature: 'Klantenhandtekening',
        Deductions: 'Aftrekken',
        DeliveryAssignee: 'Leveringsverantwoordelijke',
        DispatchClosed: 'Verzending Gesloten',
        DispatchComments: 'Verzendcommentaar',
        DispatchLog: 'Verzendlog',
        DistributionZone: 'Distributiezone',
        Driver: 'Chauffeur',
        DriverAttachments: 'Bestuurder Bijlagen',
        DriverNotes: 'Bestuurder Notities',
        DriverTrackingLink: 'Bestuurder Volg Link',
        DropoffAddress: 'Afgifte Adres',
        DropoffApt: 'Afgifte Appartement',
        DropoffCityTown: 'Afgifte Stad Plaats',
        DropoffMapUrl: 'Afgifte Google Map URL',
        DropoffPostalCode: 'Afgifte Postcode',
        DropoffStDr: 'Afgifte Straat Dr',
        DropoffUnit: 'Afgifte Eenheid',
        Email: 'E-mail',
        EndWindow: 'Eindvenster',
        EtaLink: 'Eta Link',
        NumberOfExchanges: 'Aantal Ruilen',
        ExtraAttachments: 'Extra Bijlagen',
        GeoLocation: 'Geolocatie',
        HourlyWork: 'Uurwerk',
        Invoice: 'Factuur',
        CoastInvType: 'Coast Inv Type',
        IsMetroCubeOrigin: 'Is Metro Cube Oorsprong',
        KmDriven: 'Km gereden',
        LastArchived: 'Laatste Gearchiveerd',
        LastAutobilled: 'Laatste Autofacturatie',
        LastMetroUpdate: 'Laatste Metro Update',
        LastTookanSync: 'Laatste Tookan Sync',
        Latitude: 'Breedtegraad',
        Liabilities: 'Aansprakelijkheden',
        LinkedOrder: 'Gelinkte Bestelling',
        LocationAccuracy: 'Locatie Nauwkeurigheid',
        Longitude: 'Lengtegraad',
        MetroNeedUpdate: 'Metro Update Nodig',
        NumberPastDoor: 'Aantal Voor Deur',
        NumberPriorToDoor: 'Aantal Voor Deur',
        NewOrderAttachments: 'Nieuwe Bestelling Bijlagen',
        NoCharge: 'Geen Kosten',
        OpsBilling: 'Ops Billing',
        OpsMargin: 'Ops Marges',
        OutOfTown: 'Buiten Stad',
        OverridePickupApt: 'Overschrijf Ophalen Apt',
        OverridePickupCityTown: 'Overschrijf Ophalen Stad Plaats',
        OverridePickupPostalCode: 'Overschrijf Ophalen Postcode',
        OverridePickupStDr: 'Overschrijf Ophalen Straat Dr',
        OverridePickupUnit: 'Overschrijf Ophalen Eenheid',
        Phone1: 'Telefoon1',
        Phone2: 'Telefoon2',
        ClientSubUnit: 'Client Sub Eenheid',
        PickupAddress: 'Ophalen Adres',
        PickupApt: 'Ophalen Appartement',
        PickupByLinehaul: 'Ophalen Door Linehaul',
        PickupCityTown: 'Ophalen Stad Plaats',
        PickupMapUrl: 'Ophalen Google Map URL',
        PickupPostalCode: 'Ophalen Postcode',
        PickupStDr: 'Ophalen Straat Dr',
        PickupUnit: 'Ophalen Eenheid',
        OrderType: 'Bestellingstype',
        PickupCityDistance: 'Ophalen Stad Afstand',
        PickupGeoLocation: 'Ophalen Geo Locatie',
        PickupLatitude: 'Ophalen Breedtegraad',
        PickupLocationAccuracy: 'Ophalen Locatie Nauwkeurigheid',
        PickupLongitude: 'Ophalen Lengtegraad',
        PlannedStops: 'Geplande Stops',
        Pod: 'POD',
        ProductCount: 'Aantal Producten',
        ProductJson: 'Product Json',
        Products: 'Producten',
        ProductsArrival: 'Producten Aankomst',
        PushTime: 'Push Tijd',
        DriverPushStatus: 'Bestuurder Push Status',
        ReceivedInWh: 'Ontvangen In Wh',
        Region: 'Regio',
        RequestedDeliveryWindow: 'Gevraagde Leveringsvenster',
        ScannedBarcodes: 'Ingescande Barcodes',
        ServiceTime: 'Service Tijd',
        ShippedOut: 'Verzonden',
        Skus: 'Skus',
        StairsOver3rdFloor: 'Trappen boven 3e verdieping',
        StartWindow: 'Startvenster',
        StartedAt: 'Gestart Op',
        OpsStatuses: 'Ops Statussen',
        Stem: 'Stam',
        StemKms: 'Stem Kms',
        Store: 'Winkel',
        Swamper: 'Swamper',
        SwamperEnd: 'Swamper Einde',
        SwamperStart: 'Swamper Begin',
        TextMsgLogs: 'SMS Log',
        TimeOffset: 'Tijd Verschuiving',
        TookanStatus: 'Tookan Status',
        TookanId: 'Tookan Id',
        Vehicle: 'Voertuig',
        UniqueOrderId: 'Unieke Bestel Id',
        User: 'Gebruiker',
        VaultId: 'Kluis Id',
        Volume: 'Volume',
        WhirlpoolLoadId: 'Whirlpool Laad Id',
        AutoBillEdited: 'Auto Factuur Bewerkt',
        AutoBillComments: 'Auto Factuur Opmerkingen',
        ContractorBillingValidated: 'Contractor Facturering Gevalideerd',
        FileUploadsDictionary: 'Bestand Uploads Woordenboek',
        _CreatedTimestamp: 'Gemaakt Tijdstempel',
        _UpdatedTimestamp: 'Bijgewerkt Tijdstempel',
        _ImportedTimestamp: 'Geïmporteerd Tijdstempel',
        _Operation: 'Bewerking',
    },
    portal: {
        'Main Portal': 'Hoofdportal',
        'TV Portal': 'TV Portal',
        'Same Day Portal': 'Same Day Portal',
    },
    contactless: {
        'Type and select zone to map clients': 'Typ en selecteer zone om klanten te koppelen',
        'not exist': 'bestaat niet',
        'Currently Mapped Clients': 'Momenteel gekoppelde klanten',
        Updated: 'Bijgewerkte contactloze levering instellingen voor {0}',
    },
    orderStatusSettings: {
        success: {
            statusDeleted: 'Status is succesvol verwijderd',
        },
        warning: {
            cannotDeleteStatus: 'Je kunt de standaardstatus niet verwijderen',
            error: 'Er is iets misgegaan. Neem contact op met Shyftbase.',
        },
        tooltip: {
            billableSettlementRate:
                'Facturering en afwikkelings tarieven, gebruikt door de automatische factureringsmodule',
            ignoreStem: 'Schakel stemberekeningen uit',
            ignoreOptimizer: 'Als uitgeschakeld, zal de routeerengine bestellingen met deze status negeren',
            shouldLock: 'Als ingeschakeld, wordt de bestelling vergrendeld en kan deze niet meer worden bijgewerkt',
            lifeCycle: 'Definieer de fase van de leveringscyclus',
        },
    },
    clientSettings: {
        'Create a new client': 'Maak een nieuwe klant aan',
        activate: 'Activeren',
        deactivate: 'Deactiveren',
        activated: 'geactiveerd',
        deactivated: 'gedeactiveerd',
        'client name is required': 'klantnaam is verplicht',
        'Include in Inventory': 'Inclusief in Voorraad',
        'Client Name': 'Klantnaam',
        'Successfully created': 'Succesvol aangemaakt',
        'Client already exists': 'Klant bestaat al',
        'No region found': 'Geen regio gevonden',
        'Region is required': 'Regio is verplicht',
        'Type to search region': 'Typ om regio te zoeken',
        Inventory: 'Voorraad',
        'Reverse Logistics': 'Omgekeerde Logistiek',
        'Include in Reverse Logistics': 'Inclusief in Omgekeerde Logistiek',
        'Send Survey': 'Stuur Enquête',
        Yes: 'Ja',
        No: 'Nee',
        'Billing Code': 'Factureringscode',
        'Default address': 'Standaard adres',
        'Save changes': 'Wijzigingen opslaan',
        'Upload Survey Logo': 'Upload Enquête Logo',
        'Remove Survey Logo': 'Verwijder Enquête Logo',
    },
    ikeaDriverSetting: {
        'Select type to proceed': 'Selecteer type om verder te gaan',
        loading: 'laden...',
        drivers: 'chauffeurs',
        contractors: 'aannemers',
        'Create New': 'Maak nieuw',
        Update: 'Bijwerken',
        Delete: 'Verwijderen',
        Region: 'Regio',
        ID: 'ID',
        Name: 'Naam',
        Company: 'Bedrijf',
        'Company Name': 'Bedrijfsnaam',
        Active: 'Actief',
        Submit: 'Verzenden',
        Cancel: 'Annuleren',
        'successfully updated': 'succesvol bijgewerkt',
        'successfully removed': 'succesvol verwijderd',
        'No options matching the keyword': 'Geen opties die overeenkomen met het zoekwoord',
        Select: 'Selecteren',
    },
    dateRegion: {
        dateField: 'Selecteer datumveld',
        dateRange: 'Selecteer datumbereik',
        Records: 'Records',
        firebase10Limit: 'Selecteer tot 10 of alles',
        selectRequiredFields: 'Selecteer datumveld, klant(en) en terminal(s)',
        orderCountToCheck: {
            one: '{{needToCheckDispatch}} bestelling vereist aandacht',
            other: '{{needToCheckDispatch}} bestellingen vereisen aandacht',
        },
        buttons: {
            addUpload: 'Toevoegen/Uploaden',
            dedicatedOrder: 'Specifieke bestelling',
            order: 'Bestelling',
            upload: 'Uploaden',
        },
        supplyChain: {
            status: {
                pending: 'In afwachting',
                processing: 'In behandeling',
                shipped: 'Verzonden',
                delivered: 'Afgeleverd',
            },
            inventory: {
                low: 'Lage voorraad',
                outOfStock: 'Niet op voorraad',
                available: 'Op voorraad',
            },
        },
        customerShipmentNotification: {
            title: 'Nieuwe Klantverzendingen',
            message: 'Klanten hebben verzendingen geplaatst vanuit het portaal',
            info: 'Elke verzending bevat meestal zowel ophaal- als leveringsopdrachten',
            closeAriaLabel: 'Sluit melding',
        },
    },
    user: {
        deleteUserSuccessMsg: 'Gebruiker is succesvol verwijderd.',
        removUserDialogTitle: 'Verwijder Gebruiker',
        removUserDialogMsg: `Je staat op het punt {{email}} te verwijderen. Weet je het zeker?`,
    },
    generics: {
        yes: 'Ja',
        no: 'Nee',
        ok: 'Ok',
        cancel: 'Annuleren',
        save: 'Opslaan',
        close: 'Sluiten',
        delete: 'Verwijderen',
        edit: 'Bewerken',
        add: 'Toevoegen',
        remove: 'Verwijderen',
        update: 'Bijwerken',
        create: 'Aanmaken',
        search: 'Zoeken',
        filter: 'Filteren',
        volume: 'Volume',
        weight: 'Gewicht',
    },
    productDetails: {
        Destination: 'Bestemming',
        ReverseLogisticsBarcode: 'Omgekeerde Barcode',
        ServiceTime: 'Service Tijd',
        shyftCodeTooltip: 'Shyftbase gegenereerde barcode',
        Barcode: 'Barcode',
        Shyftcode: 'Shyftcode',
        BolNumber: 'Laatste BoL',
        Comment: 'Opmerking',
        Mfr: 'Fabrikant',
        Model: 'Model',
        OriginHub: 'OorsprongHub',
        Product: 'Product',
        Quantity: 'Hoeveelheid',
        Serial: 'Serieel',
        Sku: 'Sku',
        Status: 'Status',
        Volume: 'Volume',
        Weight: 'Gewicht',
        Id: 'Id',
        PoNumber: 'PO Nummer',
        PickupByLinehaul: 'Ophalen Door Linehaul',
        BolHistory: 'BoL Geschiedenis',
        ShippingDate: 'Verzenddatum',
        BolCreatedBy: 'Gemaakt Door',
        BolOriginHub: 'Oorsprong Hub',
        BolDestinationHub: 'Bestemmings Hub',
    },
    orderTable: {
        updateNotification: {
            info: 'geüpdatete bestellingen',
            warning:
                'Selecteer de bestelling opnieuw als je van plan was deze te bewerken via het bewerkingsvenster of snelle actie.',
        },
        TimeLockedStatus: {
            warning: 'De leverdatum van deze bestelling is vergrendeld. Je kunt deze niet bewerken.',
        },
        VehicleLockedStatus: {
            warning: 'Het voertuig van deze bestelling is vergrendeld. Je kunt deze niet bewerken.',
            warningInBulk:
                'Sommige geselecteerde bestellingen hebben de status vergrendeld voertuig. Je kunt deze niet bewerken.',
        },
        contextMenu: {
            tooltip: {
                billingToggleBoth: 'Schakel de facturerings- en afwikkelingsstatussen in/uit',
                retriggerBillingModule: 'Hernieuw de facturering en afwikkelingswaarden',
                geocodeOneAtAtime:
                    'Geocodeer bestelling(en) één voor één. Dit zal de factureringsmodule opnieuw activeren.',
            },
        },
    },
    help: {
        shyftbaseGuides: 'Shyftbase Gidsen',
        searchVideoGuides: 'Zoek videogidsen op onderwerp, titel of zoekwoord',
        dispatch: 'Verzending',
        routing: 'Routing',
        network: 'Netwerk',
        admin: 'Admin',
        driver: 'Chauffeur',
        inventory: 'Voorraad',
        billingModule: 'Factureringsmodule',
        howToCreateOrders: 'Hoe bestellingen te maken',
        howToDispatchOrders: 'Hoe bestellingen naar chauffeurs te sturen',
        howToRescheduleOrders: 'Hoe bestellingen te herplannen',
        howToPlaceRoboCalls: 'Hoe robocalls te plaatsen',
        howToSearchForAnything: 'Hoe naar iets te zoeken',
        howToPrintReportsInvoicesAndLabels: 'Hoe rapporten, facturen en labels af te drukken',
        howToApproveOrdersFromStores: 'Hoe bestellingen van winkels goed te keuren',
        howToCreateViewsOrShareViews: 'Hoe weergaven te maken of te delen',
        howToUseOrderTableFiltersGroupingsAndSorting:
            'Hoe de bestellingsfilters, groeperingen en sortering te gebruiken',
    },
    asset: {
        messages: {
            updateSuccess: 'Activa succesvol bijgewerkt',
            createSuccess: 'Activa succesvol aangemaakt',
            error: 'Er is iets misgegaan. Probeer het opnieuw',
            deleteSuccess: 'Activa succesvol verwijderd',
            errorDelete: 'Er is iets misgegaan. Probeer het opnieuw',
        },
    },
}
